<template>
  <div class="popularActivities">
    <div class="banner"></div>
    <div class="content" v-show="!showLoading">
      <ul class="datalist-show" >
        <li v-for="(item, index) in dataList" :key="index" @click="clickJump(item)">
          <div class="box">
            <img :src="item.image" alt="" class="bgimg"/>
          </div>
          <div class="mask">
            <div class="line"></div>
            <div class="name-title">{{ item.title }}</div>
            <div class="line"></div>
          </div>
          <div class="bom">
            <p class="p-bom">{{ item.title }}</p>
            <p class="p-bom-s2">{{ item.describe }}</p>
            <p class="p-bom3">
              <span class="spm1">查看详情</span>
              <span class="span-time">{{item.createTime.slice(0,10)}}</span>
            </p>
          </div>
        </li>
      </ul>
      <div class="table-fenye">
        <el-pagination class="fenye-box" @current-change="handleCurrentChange" :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper" :total="total"></el-pagination>
      </div>
    </div>
    <div class="loading-box" v-show="showLoading">
      <div class="loading-content" >
        <div class="point1"></div>
        <div class="point2"></div>
        <div class="point3"></div>
      </div>
    </div>
  </div>
</template>
        
<script>
import * as api from "../api"
export default {
  data() {
    return {
      dataList:[],
      currentPage:1,
      showLoading:true,
      pageSize:8,
      total:0,
    };
  },
  mounted () {
    this.getData()
  },
  methods: {
    getData(){
        this.showLoading = true
         api.getDataApi(5,this.currentPage,this.pageSize).then(res=>{
            console.log(res.data,"aaa");
            if(res){
              this.showLoading = false
              this.dataList = res.data.list
              this.total = res.data.total
            }else{
              this.showLoading = true
            }
          })
    },
    clickJump(item){
      console.log(item);
      window.open(`${item.jumpUrl}`)
    },
    handleCurrentChange(i){
        console.log(i);
        this.currentPage = i
        this.getData()

    }
  }
};
</script>
<style lang='less' scoped>
.popularActivities {
  width: 100%;
  text-align: left;
  .banner {
    width: 100%;
    height: 450px;
    background-image: url('./banner-pc-img/img-anli-bg-tuya.png');
    background-size: 100%;
    background-repeat: no-repeat;
  }
}
.content {
  width: 90%;
  margin: 0 auto;
  margin-bottom: 30px;
  > .datalist-show {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-top: 60px;
    // justify-content: space-around;
    li {
      width: 23%;
      // height: 363px;
      position: relative;
      cursor: pointer;
      margin-bottom: 40px;
      margin-left: 40px;
      .box {
        width: 100%;
        height: 260px;
        overflow: hidden;
        img {
          width: 100%;
          height: 100%;
          transition: all 0.3s linear;
        }
      }
      .mask {
        width: 100%;
        height: 260px;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transition: all 0.3s linear;
        .line {
          width: 150px;
          height: 1px;
          background-color: #fff;
          transition: all 0.3s linear;
        }
        .name-title {
          margin-top: 9px;
          margin-bottom: 9px;
          color: #fff;
          font-size: 16px;
          line-height: 16px;
        }
      }
      .bom {
        width: 100%;
        padding: 15px 20px 10px;
        box-sizing: border-box;
        border: 1px solid #f2f2f2;
        text-align: left;
        .p-bom {
          width: 100%;
          line-height: 23px;
          text-align: left;
          color: #000;
          font-size: 22px;
          // 不换行超出显示。。。
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          margin-bottom: 20px;
        }
        .p-bom-s2{
            width: 100%;
            line-height: 23px;
            text-align: left;
            color: #000;
            font-size: 20px;
            color: gray;
            letter-spacing: 1px;
            padding: 10px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            margin-bottom: 10px;
        }
        .p-bom3 {
          width: 100%;
          border-top: 1px solid #eee;
          padding: 5px 0px;
          padding-top: 12px;
          padding-right: 10px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          img {
            width: 24px;
            height: 8px;
            margin-right: 20px;
            background-image: url();
          }
          .span-time{
            color: grey;
            letter-spacing: 1px;
          }
          >.white-icon{
              display: block;
          }
          >.black-icon{
              display: none;
          }
          &:hover {
            .black-icon{
                display: block;
            }
            .white-icon{
                display: none;
            }
          }
          .spm1 {
            margin-left: 20px;
            color: #777;
            font-size: 14px;
          }
        }
      }
    }
    li:hover .mask {
      opacity: 1;
    }
    li:hover .line {
      width: 40px;
    }
    li:hover .bgimg {
      transform: scale(1.1);
    }
  }
  .table-fenye{
                    width: 100%;
                    height: 75px;
                    background-color: #fff;
                    margin-top: 20px;
                    padding-right: 40px;
                    .fenye-box{
                        width: 100%;
                        height: 100%;
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                    }
                    /deep/ .btn-prev{
                            color: rgba(0,0,0,.65);
                            border-color: #d9d9d9;
                            background-color: #fff;
                            border: 1px solid #d9d9d9;
                            border-radius: 5px;
                            padding: 0px!important;
                            width: 40px;
                            height: 44px;
                            line-height: 44px;
                            margin-left: 13px;
                            i{
                                font-size: 24px!important;
                                font-weight: 500;
                                color: rgba(0,0,0,.65);
                            }
                        }
                        /deep/ .number{
                            color: rgba(0,0,0,.65);
                            border-color: #d9d9d9;
                            background-color: #fff;
                            border: 1px solid #d9d9d9;
                            border-radius: 5px;
                            padding: 0px!important;
                            min-width: 43px;
                            padding: 0 6px!important;
                            height: 44px;
                            line-height: 44px;
                            font-size: 22px!important;
                            font-weight: 500;
                            color: rgba(0,0,0,.65);
                            margin-left: 13px;
                            transition: all 0.2s linear;
                        }
                        /deep/ .number:hover{
                            border-color: #1890ff;
                            color: #1890ff;
                        }
                        /deep/ .active{
                            border-color: #1890ff;
                            color: #1890ff; 
                        }
                        /deep/ .btn-quickprev{
                            width: 40px;
                            height: 44px;
                            line-height: 44px;
                        }
                        /deep/ .btn-quicknext{
                            width: 40px;
                            height: 44px;
                            line-height: 44px;
                        }
                        /deep/ .btn-next{
                            color: rgba(0,0,0,.65);
                            border-color: #d9d9d9;
                            background-color: #fff;
                            border: 1px solid #d9d9d9;
                            border-radius: 5px;
                            padding: 0px!important;
                            width: 43px;
                            height: 44px;
                            line-height: 44px;
                            margin-left: 13px;
                            i{
                                font-size: 24px!important;
                                font-weight: 500;
                                color: rgba(0,0,0,.65);
                            }
                        }
                        /deep/ .el-pagination__jump{
                            width: 140px;
                            height: 44px;
                            line-height: 44px;
                            display: flex;
                            align-items: center;
                            justify-content: space-around;
                        }
                        /deep/ .el-input{
                            width: 60px;
                            height: 44px;
                            line-height: 44px;
                            padding: 0px!important;
                        }
                        /deep/ .el-pagination__editor{
                            margin: 0px!important;
                        }
                        /deep/ .el-input__inner{
                            width: 60px;
                            height: 44px;
                            line-height: 44px;
                            padding: 0px!important;
                            font-size: 22px!important;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }
                        /deep/ .el-pagination__total{
                            font-size: 22px;
                        }
                        /deep/ .el-pagination__jump{
                            font-size: 22px;
                        }
  }
}
.loading-box{
   width: 71.5%;
   height: 925px;
   margin: 0 auto;
   background-color: #fff;
   margin-bottom: 30px;
   position: relative;
   .loading-content{
                width: 150px;
                height: 100px;
                text-align: center;
                line-height: 100px;
                position: absolute;
                top: 0px;
                right: 0;
                left: 0;
                bottom: 0;
                margin: auto;
                div {
                    width: 15px;
                    height: 15px;
                    background-color: blue;
                    border-radius: 100%;
                    display: inline-block;
                    animation: action 1.5s infinite ease-in-out;
                    animation-fill-mode: both;
                    margin-right: 15px;
                }
                .point1 {
                    animation-delay: -0.3s;
                }
                .point2 {
                    animation-delay: -0.1s;
                }
            }
            @keyframes action {
                0%, 80%, 100% {
                    transform: scale(0);
                }
                40% {
                    transform: scale(1.0);
                }
            }
        }
</style>